export enum TreeNodeStatus {
  CHECKED = 'Checked',
  UNCHECKED = 'Unchecked',
  PARTIALLY_CHECKED = 'Partially Checked'
}

export const getStatusTypeFrom = (status: string) => {
  if (status === 'Checked') {
    return TreeNodeStatus.CHECKED;
  }
  if (status === 'UnChecked') {
    return TreeNodeStatus.UNCHECKED;
  }
  if (status === 'PartialCheck') {
    return TreeNodeStatus.PARTIALLY_CHECKED;
  }
};
